import { AxiosError, AxiosResponse, default as axios } from 'axios';
import * as status from 'http-status-codes';
import { BusinessUser, BusinessUnit } from '../Model';
import { Auth } from '@trustpilot/ecommscript-integrationappauth';
import { logError } from './ecommscriptClient';
import { Tools } from '../Tools';

const api = `${process.env.REACT_APP_B2bApiUrl}/v1/private`;

export const getBusinessUnits = (): Promise<BusinessUnit[]> => {
    const headers = {
        'authorization': `Bearer ${Auth.getAccessToken()}`,
        'Content-Type': 'application/json',
    };
    return axios
        .get(`${api}/me`, { headers })
        .then((meResponse: AxiosResponse<{ businessUser: BusinessUser }>) => {
            if (meResponse.status === status.OK) {
                const businessUser = meResponse.data.businessUser;
                return axios.get(`${api}/business-users/${businessUser.id}/business-units`, { headers })
                    .then((response: AxiosResponse<{ businessUnits: BusinessUnit[] }>) => {
                        if (response.status === status.OK) {
                            return Promise.all(response.data.businessUnits.map((businessUnit: BusinessUnit) => {
                                return axios.get(`${api}/business-units/${businessUnit.id}`, { headers });
                            })).then((values: Array<AxiosResponse<BusinessUnit>>) => {
                                return values.map((value: AxiosResponse<BusinessUnit>) => {
                                    if (value.status === status.OK) {
                                        return {
                                            id: value.data.id,
                                            name: {
                                                identifying: value.data.name!.identifying,
                                            },
                                        };
                                    } else {
                                        throw new Error(`Failed to get business unit. Reason: ${value.data}`);
                                    }
                                });
                            });
                        } else {
                            throw new Error(`Failed to get business units. Reason: ${response.data}`);
                        }
                    });
            } else {
                throw new Error(`Failed to get business user. Reason: ${meResponse.data}`);
            }
        }).catch((err: AxiosError) => {
            logError({
                message: `Failed on getBusinessUnits with request headers ${JSON.stringify(headers)}`,
                error: JSON.stringify(err)
            });
            Tools.resetTokenIfUnauthorized(err.response);
            return [];
        });
};

export const getBusinessUser = (): Promise<BusinessUser | undefined> => {
    const headers = {
        'authorization': `Bearer ${Auth.getAccessToken()}`,
        'Content-Type': 'application/json',
    };
    return axios
        .get(`${api}/me`, { headers })
        .then((meResponse: AxiosResponse<{ businessUser: BusinessUser}>) => {
            if (meResponse.status === status.OK) {
                return meResponse.data.businessUser;
            } else {
                throw new Error(`Failed to get business user. Reason: ${meResponse.data}`);
            }
        }).catch((err: AxiosError) => {
            logError({
                message: `Failed on getBusinessUser with request headers ${JSON.stringify(headers)}`,
                error: JSON.stringify(err)
            });
            return undefined;
        });
};



// WEBPACK FOOTER //
// ./src/Api/businessUserClient.ts